import { Array, Record, Static, String, Tuple } from 'runtypes';

export const MarketSubsetRuntype = Record({
  id: String,
  name: String,
  dates: Array(String),
});

export const SelectedMarketDatesArrayValueRuntype = Record({
  selectedDates: Array(String),
  market: MarketSubsetRuntype,
});

export const SelectedMarketDatesArrayRuntype = Array(
  Tuple(String, SelectedMarketDatesArrayValueRuntype),
);

export type SelectedMarketDatesArray = Static<
  typeof SelectedMarketDatesArrayRuntype
>;
export type SelectedMarketDatesArrayValue = Static<
  typeof SelectedMarketDatesArrayValueRuntype
>;
